import { motion } from "framer-motion";

const POLICIES = {
  terms: {
    eyebrow: "LEGAL",
    title: "Terms of Service",
    sections: [
      { h: "Research Use Only", t: "All products sold by SFH Biohealth & Wellness are intended strictly for laboratory research and analytical purposes. They are not for human or veterinary consumption, diagnostic use, or therapeutic use. By purchasing, you confirm you are a qualified researcher and will handle all materials accordingly." },
      { h: "Age Requirement", t: "You must be at least 21 years of age to access or purchase from this website. By entering the site and placing an order, you certify that you meet this requirement." },
      { h: "No Medical Claims", t: "Nothing on this website constitutes medical advice. We make no claims regarding the diagnosis, treatment, cure, or prevention of any disease. Product descriptions summarize published research areas only." },
      { h: "Orders & Payment", t: "Orders placed through this website are order requests. Payment is arranged directly with you after your order is received. We reserve the right to refuse or cancel any order at our discretion." },
      { h: "Limitation of Liability", t: "SFH Biohealth & Wellness is not liable for any misuse of products purchased from this site. All materials are handled and used at the buyer's own risk and responsibility." },
      { h: "Governing Law", t: "These terms are governed by the laws of the State of New Jersey, USA." },
    ],
  },
  privacy: {
    eyebrow: "LEGAL",
    title: "Privacy Policy",
    sections: [
      { h: "What We Collect", t: "When you place an order we collect your name, email address, shipping address, and order details. We also store your age-gate confirmation and cart contents locally in your browser." },
      { h: "How We Use It", t: "Your information is used only to process and fulfill your order, communicate about your order, and arrange payment. We do not sell, rent, or share your personal information with third parties for marketing." },
      { h: "Emails", t: "Order confirmations and order notifications are sent through our email provider (Resend). Your email address is used solely for order-related communication." },
      { h: "Data Security", t: "Order data is stored securely and access is restricted. No payment card information is ever collected or stored by this website." },
      { h: "Your Rights", t: "You may request a copy or deletion of your personal data at any time by contacting info@sfhbiohealthandwellness.com." },
    ],
  },
  shipping: {
    eyebrow: "LEGAL",
    title: "Shipping Policy",
    sections: [
      { h: "Processing Time", t: "Orders are processed within 1–3 business days after payment is confirmed. You will receive a confirmation once your order ships." },
      { h: "Shipping Area", t: "We currently ship within the United States only." },
      { h: "Packaging", t: "All compounds are lyophilized and shipped in protective packaging. Temperature-sensitive items are packed with appropriate insulation where required." },
      { h: "Delays & Issues", t: "If your order is delayed, lost, or arrives damaged, contact us at info@sfhbiohealthandwellness.com and we will make it right." },
    ],
  },
  refunds: {
    eyebrow: "LEGAL",
    title: "Refund & Return Policy",
    sections: [
      { h: "Research Materials", t: "Due to the nature of research compounds, all sales are final once an order has shipped." },
      { h: "Damaged or Incorrect Orders", t: "If your order arrives damaged, incorrect, or incomplete, contact us within 7 days of delivery at info@sfhbiohealthandwellness.com with your order number and a photo. We will replace the item or issue store credit at our discretion." },
      { h: "Cancellations", t: "Unpaid order requests may be cancelled at any time before payment. Once payment is arranged and the order is marked paid, cancellations are reviewed case by case." },
    ],
  },
};

export default function PolicyPage({ type }) {
  const policy = POLICIES[type] || POLICIES.terms;
  return (
    <main className="pt-24">
      <div className="mx-auto max-w-3xl px-6 py-16">
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="font-mono text-[11px] tracking-[0.35em] text-[#00ff72]">
          {policy.eyebrow} — SFH BIOHEALTH &amp; WELLNESS
        </motion.p>
        <h1 data-testid="policy-title" className="mt-3 font-display text-5xl tracking-tight text-[#F9F6F0] md:text-6xl">
          {policy.title}
        </h1>
        <div className="mt-10 space-y-8">
          {policy.sections.map((s, i) => (
            <motion.div
              key={s.h}
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 + i * 0.06 }}
              className="border-t border-white/10 pt-6"
            >
              <h2 className="font-mono text-xs tracking-[0.25em] text-[#00ff72]">
                {String(i + 1).padStart(2, "0")} — {s.h.toUpperCase()}
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-[#A3A3A3]">{s.t}</p>
            </motion.div>
          ))}
        </div>
        <p className="mt-12 border border-white/10 p-5 font-mono text-[10px] leading-relaxed tracking-wider text-[#666666]">
          QUESTIONS ABOUT THIS POLICY: INFO@SFHBIOHEALTHANDWELLNESS.COM — 4201 NESHAMINY BLVD #273, BENSALEM, PA 19020
        </p>
      </div>
    </main>
  );
}
